import { AnyAction, applyMiddleware, createStore, Reducer, Store } from "redux";
import { AppReducer } from "@10x/coreapp";
import { Persistor, persistReducer, persistStore } from "redux-persist";
import createReducer from "@my-dld/reducers";
import thunk from "redux-thunk";
import { composeEnhancers, history, middleWares, persistConfig } from "@my-dld/reducers/store";
import { BaseService } from "./Service";

export interface StoreService extends BaseService {
	registerReducer( name: string, reducer: Reducer ): void;

	dispatch( action: AnyAction ): void;

	getStore(): Store<AppReducer>;

	getPersistor(): Persistor;
}

class StoreServiceImpl implements StoreService {
	readonly reducers: { name: string, reducer: Reducer }[] = [];
	store?: Store<AppReducer>;
	persistor?: Persistor;

	registerReducer( name: string, reducer: Reducer ): void {
		this.reducers.push( { name, reducer } );
	}

	getStore() {
		if ( this.store == null ) {
			this.buildStore();
		}
		return this.store!;
	}

	dispatch( action: AnyAction ): void {
		this.store?.dispatch( action );
	}

	getPersistor(): Persistor {
		return this.persistor!;
	}

	onInitDone(): void {
		this.buildStore();
	}

	buildStore() {
		const xReducers = this.reducers.reduce( ( p, c ) => {
			return {
				...p,
				[ c.name ]: c.reducer
			};
		}, {} );
		const persistedReducer = persistReducer( persistConfig, createReducer( history, xReducers ) );
		this.store = createStore( persistedReducer, composeEnhancers( applyMiddleware( thunk, ...middleWares ) ) );
// export default store;
		this.persistor = persistStore( this.store );

	}

}

const storeService = new StoreServiceImpl();
export default storeService;
